import React from 'react';
import { useSelector } from 'react-redux';
import { BoardingPointComponent } from './boarding-points.component';
import { tripReducerSelector } from '../../../selector/trip-selectors';

export const BoardingPointsComponent = (props) => {

    let tripReducer = useSelector(tripReducerSelector);

    return (
        <div>
            <BoardingPointComponent
                {...tripReducer}
                isRowClickable={true}
                showDeleteUpdateButtons={true}
            />
        </div>
    );
}
